// eslint-disable-next-line max-len
var USER_INTERFACE_TICK_DONE = 'M31.58,6.61l-18,21.05a1.74,1.74,0,0,1-1.2.61,1.77,1.77,0,0,1-1.28-.43L.6,18.7h0a1.75,1.75,0,0,1,2.3-2.64l9.16,8L28.92,4.34a1.75,1.75,0,0,1,2.66,2.27Z';

export { USER_INTERFACE_TICK_DONE };
//# sourceMappingURL=USER_INTERFACE_TICK_DONE.js.map
